<template>
  <div class="allInOneContent">
    <div class="topBox">
      <div class="topTitle">一体机</div>
      <!-- <div class="topText">STW32/43/49-V5</div> -->
      <img :src="AllInOne1" class="topImg" alt>
    </div>
    <div class="allInOneParent" style="margin-top:104px;">
      <div class="allInOneLeft">
        <div class="boxTitleBox">
          <div class="boxTitle">1080高清显示屏</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">
          远程发布，定时开关机，分时定时播放，
          网络自我诊断，屏幕旋转。
        </div>
      </div>
      <div class="allInOneRight">
        <img :src="AllInOne2" alt>
      </div>
    </div>
    <!-- start -->
    <div class="allInOneParent marginTop100">
      <div class="allInOneLeft" style="width:50%;padding-left:0;">
        <img :src="AllInOne3" class="leftImg1" alt>
      </div>
      <div class="allInOneRight" style="width:40%;padding-left:10%;">
        <div class="boxTitleBox">
          <div class="boxTitle">广视角盛宴</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">
          广视角屏幕，全方位展示，从正面、
          侧面，上下效果一样，没有偏差。
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="allInOneParent marginTop100">
      <div class="allInOneLeft">
        <div class="boxTitleBox">
          <div class="boxTitle">分身有术 从容应对</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">
          一屏多用，自由选择不停区域，
          文字分区播放的显示内容、视频、图片。
        </div>
      </div>
      <div class="allInOneRight">
        <img :src="AllInOne4" alt>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="allInOneParent marginTop100">
      <div class="allInOneLeft" style="width:50%;padding:0">
        <img :src="AllInOne5" class="leftImg1" alt>
      </div>
      <div class="allInOneRight" style="width:40%;padding-left:10%">
        <div class="boxTitleBox">
          <div class="boxTitle">广告自动循环播放</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">
          方便快捷，自动识别系统，插入U盘
          或SD卡即可自动播放里面的内容。
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="allInOneParent marginTop100">
      <div class="allInOneLeft">
        <div class="boxTitleBox">
          <div class="boxTitle">WIFI连接 远程管控</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">
          以太网支持
          (3G、4G非标配）
          可任选一项连接电脑，远程发布广告，
          管理节目。
        </div>
      </div>
      <div class="allInOneRight">
        <img :src="AllInOne6" alt>
      </div>
    </div>
    <!-- end -->
    <div class="bottomImgBox">
      <img :src="AllInOne7" class="" alt>
    </div>
  </div>
</template>
<script>
import AllInOne1 from "@/assets/images/AllInOne1.png";
import AllInOne2 from "@/assets/images/AllInOne2.png";
import AllInOne3 from "@/assets/images/AllInOne3.png";
import AllInOne4 from "@/assets/images/AllInOne4.png";
import AllInOne5 from "@/assets/images/AllInOne5.png";
import AllInOne6 from "@/assets/images/AllInOne6.png";
import AllInOne7 from "@/assets/images/AllInOne7.png";
import AllInOne8 from "@/assets/images/AllInOne8.png";
import AllInOne9 from "@/assets/images/AllInOne9.png";
export default {
  data() {
    return {
      AllInOne1: AllInOne1,
      AllInOne2: AllInOne2,
      AllInOne3: AllInOne3,
      AllInOne4: AllInOne4,
      AllInOne5: AllInOne5,
      AllInOne6: AllInOne6,
      AllInOne7: AllInOne7,
      AllInOne8: AllInOne8,
      AllInOne9: AllInOne9
    };
  }
};
</script>
<style scoped>
.allInOneContent {
  width: 70%;
  margin: auto;
  font-size: 0;
}
.topBox {
  text-align: center;
  margin-top: 114px;
}
.topTitle {
  font-size: 4rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(88, 89, 89, 1);
}
.topText {
  margin-top: 20px;
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(153, 153, 153, 1);
}
.topImg {
  width: 50%;
  max-width: 648px;
  margin-top: 20px;
}
/* start */
.boxTitle {
  font-size: 4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  margin-top: 30%;
}
.boxTitleLine {
  width: 80px;
  height: 4px;
  margin-top: 20px;
  background: rgba(252, 200, 0, 1);
}
/* end */
.allInOneParent::after {
  content: "";
  display: block;
  clear: both;
}
.allInOneParent {
  margin-top: 20px;
}
.allInOneLeft {
  width: 40%;
  padding-left: 10%;
  float: left;
}
.boxTitleBox {
}
.allInOneRight {
  width: 50%;
  float: left;
}
.allInOneRight img {
  width: 100%;
}
.boxP {
  width: 70%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  margin-top: 40px;
  text-align: left;
  line-height: 40px;
}
.leftImg1 {
  width: 100%;
 
}
.marginTop100 {
  margin-top: 0px;
}
.bottomImgBox {
  margin-top: 45px;
  text-align: center;
}
.bottomImgBox img {
  width: 100%;
  max-width: 1200px;
}
.textCenter {
  text-align: center;
}
.marginAuto {
  margin: auto;
  margin-top: 20px;
}
.marginTop28 {
  margin-top: 28px;
}
.marginTop40 {
  margin-top: 40px;
}
</style>





// WEBPACK FOOTER //
// src/view/hardware/allInOne.vue